const id = {
  "home": "Beranda", // 单词翻译
  "profile": "Profil", // 单词翻译
  "product": "Produk", // 单词翻译
  "select": "Pilih", // 单词翻译
  "selected": "Terpilih", // 单词翻译
  "address": "Alamat", // 单词翻译
  "description": "Deskripsi", // 单词翻译
  "lease": "Sewa", // 单词翻译
  "leaseTips": "Dalam Pengiriman, Paket Anda sedang dalam pengiriman【DR_Dennis Gonzales : 9458674829】Untuk COD harap siapkan jumlah yang tepat, Foto bukti pengiriman diperlukan. Terima kasih!",
  "buyNow": "Beli Sekarang", // 单词翻译
  "unavailable": "Tidak Tersedia", // 单词翻译
  "priceUnit": "Rp", // 金额单位
  "confirm": "Konfirmasi", // 单词翻译
  "cancel": "Batal", // 单词翻译
  "back": "Kembali",
  "close": "Tutup",
  "appName": "Genggo",
  "loading": "Memuat...", // 加载中提示 单词翻译
  "logout": "Keluar", // 单词翻译
  "loginExpired": "Login gagal. Silakan login lagi", // 登录过期提示
  "addAddress": "Tambah Alamat", // 单词翻译
  "addressList": "Daftar Alamat", // 单词翻译
  "default": "Default", // 单词翻译
  "language": "Bahasa", // 单词翻译
  "FAQ": "FAQ", // 单词翻译
  "customerService": "Layanan Pelanggan",
  "customerServicePop": {
    "whatsapp": "WhatsApp",
    "copy": "Salin",
    "copySuccess": "Disalin"
  },
  "customerSupportFloating": {
    "whatsapp": "WhatsApp",
    "expand": "Buka dukungan WhatsApp",
    "collapse": "Tutup dukungan WhatsApp",
    "open": "Chat dengan dukungan WhatsApp",
    "online": "ONLINE SEKARANG",
    "title": "Dukungan WhatsApp",
    "subtitle": "Ketuk untuk chat dengan Genggo"
  },
  "edit": "Edit", // 单词翻译
  "delete": "Hapus", // 单词翻译
  "addSuccess": "Berhasil ditambahkan", // 单词翻译
  "saveSuccess": "Berhasil disimpan", // 单词翻译
  "deleteSuccess": "Berhasil dihapus", // 单词翻译
  "noMore": "Tidak ada lagi", // 没有更多数据提示
  "languageSettings": "Pengaturan Bahasa", // 单词翻译
  "systemError": "System error, please try again later", // 系统错误提示
  "withholdingAuth": {
    "title": "Aktifkan pembayaran otomatis",
    "subtitle": "Otorisasi DANA untuk membayar tagihan sewa mendatang.",
    "description": "Kami akan otomatis memulai pembayaran pada setiap tanggal jatuh tempo untuk membantu Anda menghindari pembayaran yang terlewat dan biaya keterlambatan.",
    "agreePrefix": "Saya telah membaca dan menyetujui ",
    "agreement": "Perjanjian Otorisasi Debit Otomatis",
    "notNow": "Nanti saja",
    "authorize": "Otorisasi"
  },
  "retry": "Coba lagi",
  "indexPage": {
    "title": "Beranda", // 首页标题
    "productTitle": "Produk", // 首页产品列表标题
    "greeting": "Halo",
    "subtitle": "Punya iPhone impian kini lebih mudah.",
    "bannerAriaLabel": "Promosi pilihan",
    "bannerLoadFailed": "Gagal memuat banner",
    "bannerEmptyTitle": "Belum ada banner",
    "bannerEmptyDescription": "Promosi dan pembaruan produk akan muncul di sini.",
    "shortcutsAriaLabel": "Menu pintasan beranda",
    "myProfile": "Profil Saya",
    "products": "Produk",
    "stores": "Cabang",
    "faq": "FAQ",
    "featuredProducts": "Produk Pilihan",
    "seeAll": "Lihat semua"
  },
  "bottomNav": {
    "ariaLabel": "Navigasi utama",
    "home": "Beranda",
    "products": "Produk",
    "account": "Akun"
  },
  "productCommon": {
    "firstRentalAmount": "Jumlah sewa pertama",
    "pricePending": "Harga menunggu data",
    "applyNow": "Ajukan Sekarang",
    "rented": "disewa",
    "noCreditCard": "Tanpa kartu kredit",
    "onlineProcess": "Proses online",
    "benefitSummary": "Ringkasan Keuntungan",
    "lightInstallments": "Cicilan ringan",
    "deliveryOnlineProcess": "Proses 100% Online",
    "freeShippingJabodetabek": "Gratis ongkir untuk pembayaran online"
  },
  "productState": {
    "loading": "Memuat…",
    "loadFailed": "Gagal memuat data",
    "emptyTitle": "Belum ada produk",
    "emptyDescription": "Perangkat sewa yang tersedia akan muncul di sini saat sudah siap.",
    "searchEmptyTitle": "Produk yang cocok tidak ditemukan",
    "searchEmptyDescription": "Coba kata kunci lain atau hapus pencarian."
  },
  "productsPage": {
    "title": "Produk",
    "searchPlaceholder": "Cari iPhone atau model",
    "clearSearch": "Hapus pencarian",
    "closeSearch": "Tutup pencarian",
    "recentSearches": "Pencarian terbaru",
    "clearAll": "Hapus semua",
    "deleteHistory": "Hapus riwayat pencarian",
    "recommendedForYou": "Rekomendasi untuk Anda",
    "loadMoreError": "Gagal memuat produk lainnya",
    "recommendationLoadError": "Gagal memuat rekomendasi"
  },
  "storesPage": {
    "title": "Daftar Toko",
    "emptyTitle": "Belum ada toko tersedia",
    "emptyDesc": "Saat ini belum ada toko yang tersedia di lokasi ini. Silakan coba lagi nanti.",
    "statusOpen": "Buka normal",
    "statusUpgrading": "Upgrading & Coming Soon",
    "unnamed": "Toko Genggo",
    "loadFailed": "Gagal memuat toko",
    "retry": "Coba Lagi",
    "dialFailed": "Tidak dapat membuka dialer telepon"
  },
  "faqPage": {
    "heroTitle": "Hai! Ada yang bisa kami bantu?",
    "heroSubtitle": "Temukan jawaban atas pertanyaan umum tentang layanan sewa perangkat kami.",
    "searchPlaceholder": "Cari pertanyaan…",
    "noResults": "Tidak ada pertanyaan yang cocok",
    "contactTitle": "Tidak menemukan jawaban?",
    "contactDesc": "Tim dukungan kami siap membantu pertanyaan lainnya.",
    "contactSupport": "Hubungi Dukungan",
    "helpfulQuestion": "Apakah informasi ini membantu?",
    "helpfulYes": "Ya, ini membantu",
    "helpfulNo": "Tidak, saya butuh bantuan",
    "helpfulYesToast": "Senang bisa membantu Anda."
  },
  "goodsPage": {
    "title": "Detail Produk", // 商品详情页标题
    "shippingAddress": "Alamat Pengiriman",
    "addressLoadFailed": "Alamat Anda gagal dimuat. Silakan coba lagi.",
  },
  "skuPop": {
    "chooseVariant": "Pilih Varian",
    "selection": "Pilih",
    "noSelection": "Belum dipilih",
    "noSelectAttr": "Silakan pilih {attrName}", // 没有选择sku提示
    "noSelect": "Silakan pilih sku", // 没有选择sku提示
    "noStock": "Stok Habis" // 没有库存提示
  },
  "addressPop": {
    "add": "Tambah Alamat Baru",
    "name": "Nama",
    "phone": "Nomor Telepon",
    "region": "Wilayah",
    "detail": "Alamat",
    "regionsPlaceholder": "Silakan pilih wilayah Anda", // 区域选择市列提示
    "deleteTitle": "Hapus Alamat",  // 删除地址标题
    "deleteConfirm": "Apakah Anda yakin ingin menghapus alamat ini?", // 删除地址确认
    'regionEmpty': "Silakan pilih wilayah Anda", // 区域选择为空提示
    "phoneEmpty": "Silakan masukkan nomor telepon Anda", // 手机号为空提示
    "detailEmpty": "Silakan masukkan alamat Anda", // 地址为空提示
    "nameEmpty": "Silakan masukkan nama Anda", // 姓名为空提示
    "phoneError": "Silakan masukkan nomor telepon Indonesia yang valid", // 手机号格式错误提示
    "noSelectAddress": "Silakan pilih alamat Anda", // 没有选择地址提示
  },
  "contactPop": {
    "title": "Tambah Kontak",
    "listTitle": "Kontak Referensi",
    "editTitle": "Edit Kontak",
    "subTitle": "Tetap aman dan terlindungi - tambahkan kontak darurat.",
    "selectRequired": "Silakan pilih {count} kontak referensi | Silakan pilih {count} kontak referensi",
    "contactTitle": "Personel Kontak {index}",
    "relation": "Hubungan",
    "name": "Nama",
    "phone": "Nomor Telepon",
    "submit": "Simpan",
    "addNewContact": "Tambah Kontak Baru",
    "relationEmpty": "Silakan pilih hubungan kontak darurat",
    "nameEmpty": "Silakan masukkan nama kontak",
    "nameFormat": "Silakan masukkan nama kontak yang valid",
    "phoneError": "Silakan masukkan nomor telepon Indonesia yang valid", // 手机号格式错误提示
    "phoneRepeat": "Nomor telepon kontak tidak boleh sama.", // 手机号重复
    "selectedCount": "Terpilih {selected} dari {count}",
    "empty": "Belum ada kontak tersimpan",
    "addAnother": "Tambah kontak lain",
    "maxCount": "Anda hanya dapat memilih hingga {count} kontak",
    "deleteTitle": "Hapus kontak",
    "deleteConfirm": "Yakin ingin menghapus kontak ini?",
  },
  "myPage": {
    "title": "Profil", // 我的页面标题
    "rentalPlan": "Rencana Sewa", // 我的页面租借计划标题
    "orderList": "Daftar Pesanan", // 我的页面订单列表标题
    "additionalInfo": "Informasi Saya",
    "overdue": "Terlambat", // 我的页面逾期标题
    "payNow": "Bayar Sekarang", // 我的页面自己还款按钮
    "logoutTitle": "Keluar", // 我的页面登出标题
    "logoutContent": "Apakah Anda yakin ingin keluar?", // 我的页面登出内容
    "guest": "Tamu",
    "loginRequiredTitle": "Login diperlukan",
    "loginRequiredContent": "Anda perlu login untuk melanjutkan."
  },
  "accountPage": {
    "title": "Akun Saya",
    "avatar": "Avatar",
    "guestUser": "Pengguna Tamu",
    "verifiedMember": "Anggota Terverifikasi",
    "unverifiedMember": "Anggota Belum Terverifikasi",
    "memberSince": "Anggota sejak {date}",
    "memberSinceEmpty": "Anggota sejak —",
    "loginDescription": "Anda perlu masuk untuk melanjutkan.",
    "shortcutsAriaLabel": "Pintasan akun",
    "myOrders": "Pesanan Saya",
    "myBills": "Tagihan Saya",
    "myInformation": "Informasi Saya",
    "myInformationDescription": "Kelola informasi pribadi Anda",
    "addressesContacts": "Alamat & Kontak",
    "addressesContactsDescription": "Kelola alamat pengiriman dan kontak",
    "paymentMethods": "Metode Pembayaran",
    "paymentMethodsDescription": "Kelola akun auto-debit Anda",
    "faqDescription": "Temukan jawaban atas pertanyaan umum",
    "settings": "Pengaturan",
    "settingsDescription": "Pengaturan akun dan aplikasi",
    "supportDescription": "Dapatkan bantuan dari tim kami",
    "loadFailed": "Gagal memuat informasi akun"
  },
  "paymentMethods": {
    "title": "Akun Auto-debit",
    "description": "Kelola akun yang telah diotorisasi untuk pembayaran rental otomatis.",
    "addTitle": "Tambah akun auto-debit",
    "addDesc": "Otorisasi akun pembayaran untuk pembayaran rental otomatis.",
    "addAccount": "Tambah akun",
    "loadFailed": "Gagal memuat akun auto-debit",
    "authorizedAt": "Diotorisasi {time}",
    "unauthorizedAt": "Tidak diotorisasi {time}",
    "cancelAuthorization": "Batalkan otorisasi",
    "reauthorize": "Otorisasi ulang",
    "cancelTitle": "Batalkan otorisasi",
    "cancelDesc": "Anda yakin ingin membatalkan otorisasi ini?",
    "cancelSuccess": "Otorisasi dibatalkan",
    "status": {
      "active": "Aktif",
      "pending": "Menunggu",
      "expired": "Kedaluwarsa",
      "disconnected": "Tidak Aktif"
    }
  },
  "addressContacts": {
    "addresses": "Alamat",
    "contacts": "Kontak",
    "addContact": "Tambah Kontak",
    "goAdd": "Tambah sekarang",
    "emptyAddresses": "Belum ada alamat tersimpan",
    "emptyAddressesDesc": "Tambahkan alamat pengiriman agar checkout lebih cepat.",
    "emptyContacts": "Belum ada kontak tersimpan",
    "emptyContactsDesc": "Tambahkan kontak referensi untuk pesanan sewa Anda.",
    "contactUsageNotice": "Kami hanya dapat menghubungi mereka jika kami tidak dapat menghubungi Anda untuk konfirmasi identitas, pengiriman, pengembalian perangkat, atau hal terkait keamanan. Kami tidak akan mengungkapkan tagihan, pembayaran, atau status sewa Anda.",
    "setDefaultAddressTitle": "Jadikan alamat utama",
    "setDefaultAddressConfirm": "Anda yakin ingin menjadikan alamat ini sebagai default?"
  },
  "accountSettings": {
    "title": "Pengaturan",
    "agreementsPolicies": "Perjanjian & Kebijakan",
    "noAgreements": "Belum ada perjanjian",
    "noAgreementContent": "Isi perjanjian belum tersedia.",
    "userRegistrationAgreement": "Perjanjian Pendaftaran Pengguna",
    "privacyPolicy": "Kebijakan Privasi",
    "dataProcessingConsent": "Persetujuan Pemrosesan Data Pribadi",
    "deviceRentalAgreement": "Perjanjian Sewa Perangkat",
    "accountDeleteAgreement": "Perjanjian Penghapusan Akun",
    "aboutUs": "Tentang Kami",
    "accountSecurity": "Akun & Keamanan",
    "deleteAccount": "Hapus Akun",
    "loadFailed": "Gagal memuat pengaturan"
  },
  "aboutUs": {
    "description": "Genggo adalah platform rental perangkat pintar\nyang menyediakan perangkat berkualitas tinggi\ndan layanan andal untuk pelanggan\ndi seluruh dunia.\nMisi kami adalah membuat teknologi\nlebih mudah diakses dan nyaman untuk semua orang.",
    "officialWebsite": "Situs Web Resmi",
    "contactUs": "Hubungi Kami",
    "openFailed": "Tidak ada aplikasi untuk membuka tautan ini"
  },
  "deleteAccount": {
    "title": "Hapus Akun",
    "confirmTitle": "Apakah Anda ingin menghapus akun?",
    "confirmDescription": "Tindakan ini tidak dapat dibatalkan. Harap baca informasi di bawah dengan saksama.",
    "noteTitle": "Harap diperhatikan",
    "noteOrder": "Jika Anda memiliki pesanan rental perangkat yang sedang berjalan, Anda tidak dapat menghapus akun.",
    "noteData": "Setelah akun dihapus, semua data dan informasi Anda akan dihapus secara permanen dan tidak dapat dipulihkan.",
    "smsTitle": "Verifikasi dengan Kode SMS",
    "smsDescription": "Kami akan mengirim kode verifikasi ke nomor ponsel terdaftar Anda.",
    "codePlaceholder": "Masukkan kode SMS",
    "getCode": "Dapatkan Kode",
    "codeCountdown": "{seconds}s",
    "codeValidTip": "Kode berlaku selama 5 menit.",
    "agreementPrefix": "Saya telah membaca dan menyetujui ",
    "agreementName": "Perjanjian Penghapusan Akun",
    "agreementRequired": "Silakan setujui Perjanjian Penghapusan Akun terlebih dahulu",
    "submitConfirmTitle": "Hapus akun?",
    "submitConfirmDescription": "Setelah dikonfirmasi, akun Anda akan dihapus dan Anda akan keluar. Tindakan ini tidak dapat dibatalkan.",
    "codeFailed": "Gagal mengirim kode verifikasi",
    "successTitle": "Akun Anda telah dihapus",
    "successDescription": "Akun aplikasi Anda telah dihapus. Beberapa catatan pesanan, pembayaran, kontrak, pajak, pencegahan penipuan, dan sengketa dapat disimpan untuk keperluan hukum atau bisnis yang sah sebagaimana dijelaskan dalam Kebijakan Privasi dan Kebijakan Penghapusan Akun kami.",
    "goHome": "Ke Beranda",
    "failed": "Gagal menghapus akun"
  },
  "orderPage": {
    "orderTitle": "Detail Pesanan",  // 订单详情页面标题
    "confirmTitle": "Konfirmasi Pesanan",  // 订单确认页面标题
    "reviewRentalPlan": "Tinjau Rencana Sewa",
    "orderSafeTitle": "Pesanan Anda aman dan terlindungi",
    "orderSafeSubtitle": "Paket tanpa jaminan • Penjual terverifikasi • Perlindungan pembeli",
    "agreementTitle": "Perjanjian",
    "choosePaymentMethod": "Pilih Metode Pembayaran",
    "amountDueToday": "Jumlah Jatuh Tempo Hari Ini",
    "initialPaymentAmount": "Jumlah Pembayaran Awal",
    "rentalStartDate": "Tanggal mulai sewa", // 订单详情页面租借开始日期标题
    "returnDate": "Tanggal kembali", // 订单详情页面租借结束日期标题
    "rentalStartDateDetail": "Tanggal Mulai Sewa",
    "returnDateDetail": "Tanggal Akhir Sewa",
    "rentalDateEstimated": "Perkiraan",
    "total": "Total",   // 订单详情页面总价标题
    "deposit": "Deposit", // 订单详情页面押金标题
    "refundableParenthetical": "(Dapat Dikembalikan)",
    "rentalTerm": "Masa sewa",
    "amountPaid": "Jumlah Dibayar",
    "amountDueBeforePickup": "Jumlah yang Harus Dibayar Sebelum Pengambilan",
    "rent": "Sewa", // 订单详情页面每期租金标题
    "periodicRent": {
      "WEEKLY": "Sewa Mingguan",
      "BI_WEEKLY": "Sewa Dua Mingguan",
      "MONTHLY": "Sewa Bulanan"
    },
    "rentCycleUnit": {
      "WEEKLY": "minggu",
      "BI_WEEKLY": "2 minggu",
      "MONTHLY": "bulan"
    },
    "initialRent": "Sewa pertama", // 订单详情页面首租金标题
    "remainingRent": "Sewa tersisa",  // 订单详情页面剩余租金标题
    "repaymentDate": "Tanggal pembayaran",  // 订单详情页面还款日期标题
    "totalRentalPayments": "Total Pembayaran Sewa",
    "remainingAmountNoticeTitle": "Sisa jumlah akan ditagihkan",
    "remainingAmountNoticeDesc": "Anda dapat membayarnya pada bulan berikutnya atau setelahnya.",
    "cancelledOrderNoPaymentTitle": "Tidak ada pembayaran yang diproses",
    "cancelledOrderNoPaymentDesc": "Karena pesanan ini telah dibatalkan, tidak ada pembayaran yang diperlukan.",
    "cancelledOrderNeedHelpTitle": "Butuh bantuan?",
    "cancelledOrderNeedHelpDesc": "Jika Anda memiliki pertanyaan tentang pembatalan ini, silakan hubungi tim layanan pelanggan kami.",
    "rentalPeriodOngoingNoticeTitle": "Periode Sewa Berlangsung",
    "rentalPeriodOngoingNoticeDesc": "Periode sewa Anda telah dimulai. Harap jaga perangkat dengan baik. Hubungi kami jika Anda mengalami kendala.",
    "paymentReceivedNoticeTitle": "Terima kasih! Pembayaran Anda telah diterima.",
    "paymentReceivedNoticeDesc": "Anda akan diberi tahu setelah pesanan dikirim.",
    "payments": "pembayaran",
    "contactTitle": "Kontak",
    "addReferenceContacts": "Tambah Kontak Referensi",
    "noContacts": "Tidak ada kontak",
    "amount": "Jumlah",
    "reasonPrefix": "Alasan: ",
    "agText":"Saya telah membaca dan menyetujui ",
    "agLastText":"dan",
    "agreementCheckLabel":"Saya menyetujui perjanjian di atas",
    "agreementRequired":"Silakan setujui Perjanjian Sewa Perangkat terlebih dahulu",
    "moreAgreements": "+{count} lainnya",
    "ownershipNoticeTitle":"Pemberitahuan Kepemilikan",
    "ownershipNotice":"Jika semua pembayaran sewa dan jumlah terutang lainnya telah dibayar lunas, dan tidak ada tunggakan, perangkat akan menjadi milik Anda pada akhir masa sewa. Tidak diperlukan pengembalian perangkat setelah pengalihan kepemilikan.",
    "importantNotesTitle":"Catatan Penting",
    "importantNotes1":"Jika Anda menghentikan sewa setelah perangkat dikirimkan dan sebelum menyelesaikan tiga periode pembayaran sewa pertama, deposit tidak akan dikembalikan dan perangkat harus dikembalikan.",
    "importantNotes2":"Penghentian lebih awal juga dapat memerlukan pembayaran sewa yang terutang, biaya keterlambatan, biaya penghentian lebih awal, biaya perbaikan, biaya penggantian, kompensasi kehilangan perangkat, dan biaya lain yang berlaku.",
    "importantNotes3":" Biaya keterlambatan: Rp30.000 per hari, mulai dari hari kalender berikutnya setelah tanggal jatuh tempo.",
    "createdDate": "Tanggal dibuat",  // 订单详情页面创建日期标题
    "paymenDate": "Tanggal pembayaran",  // 订单详情页面支付日期标题
    "orderNumber": "Nomor Pesanan", // 订单详情页面订单编号标题
    "closeDate": "Tanggal ditutup",
    "closeReason": "Alasan pembatalan",
    "paymentTimeoutCancelReason": "Pembayaran kedaluwarsa dan pesanan ditutup otomatis",
    "userCancelledCloseReason": "Dibatalkan oleh pengguna",
    "cancelledOnFormat": "Dibatalkan pada {time}",
    "orderCancelledDesc": "Pesanan ini telah dibatalkan.",
    "checkout": "Konfirmasi & Lanjutkan",   // 订单详情页面去结算按钮
    "checkoutHint": "Tidak perlu melakukan pembayaran sekarang. Anda akan memilih COD atau pembayaran online setelah verifikasi ID.",
    "payNow": "Bayar Sekarang",
    "pendingPaymentTimeLimitDesc": "Harap selesaikan pembayaran dalam batas waktu.",
    "payUrlTitle": "Lanjutkan ke Pembayaran",
    "payUrlDesc": "Selesaikan pembayaran di halaman penyedia pembayaran, lalu kembali ke sini untuk memeriksa hasilnya.",
    "goToPay": "Pergi ke Pembayaran",
    "paymentCompletedButton": "Saya Sudah Menyelesaikan Pembayaran",
    "paymentNotCompleted": "Pembayaran belum selesai.",
    "orderExpired": "Pesanan Kedaluwarsa",
    "planTips": "Harap dicatat: Tanggal mulai sewa tergantung pada waktu pengiriman aktual.", // 订单详情页面租借计划提示
    "rentalStartAdjusted": "Tanggal mulai sewa disesuaikan dengan tanggal pengiriman aktual.",
    "rentalPlan": "Rencana Sewa",
    "rentalPeriodPlan": "Rencana Periode Sewa",
    "repayPlanPeriodFormat": "Ke-{period}",
    "repayPlanDueDate": "Tanggal Jatuh Tempo Sewa",
    "repayPlanAmount": "Jumlah",
    "repayPlanAutoChargeTitle": "Silakan bayar sewa sebelum tanggal jatuh tempo.",
    "repayPlanAutoChargeDesc": "",
    "orderSuccess": "Pesanan berhasil", // 订单详情页面订单成功提示
    "orderFailed": "Pesanan gagal", // 订单详情页面订单失败提示
    "addressTip": "Silakan pilih alamat Anda", // 订单详情页面请选择地址提示
    "contactTip": "Silakan masukkan kontak darurat Anda", // 订单详情页面请选择联系人提示
    "payStatus": { // 订单详情页面订单状态头部提示
      "waitingPayment": 'Menunggu Pembayaran', // 待付款
      "success": 'Pembayaran berhasil', // 支付成功
      "closed": 'Pembayaran dibatalkan',  // 支付取消
    },
    "payErrorTip": "Pesanan gagal, silakan coba lagi nanti", // 订单详情页面订单失败提示
    "checkoutTitle": "Checkout",
    "payMethodTitle": "Pilih Metode Pembayaran",
    "onlinePaymentTitle": "Pembayaran Online",
    "onlineOptionTitle": "Bayar Sekarang (QRIS)",
    "onlineOptionDesc": "Scan QR code untuk pembayaran cepat",
    "onlinePayQrisTitle": "QRIS Online Payment",
    "onlinePayQrisDesc": "Scan QR for fast payment",
    "onlinePayAggregatedTitle": "Aggregated Online Payment",
    "onlinePayAggregatedDesc": "Choose your preferred method securely",
    "codOptionTitle": "Bayar di Tempat (COD)",
    "codOptionDesc": "Bayar saat pesanan diterima",
    "storeOptionTitle": "Pembayaran Offline & Ambil di Toko",
    "storeOptionDesc": "Bayar di toko saat mengambil perangkat Anda",
    "storePickupOnly": "Hanya metode ini yang mendukung pengambilan di toko",
    "pickupStoreTitle": "Pilih toko pengambilan",
    "storeEmpty": "Tidak ada toko pengambilan yang tersedia",
    "storeLoadFailed": "Gagal memuat toko",
    "storeRequired": "Silakan pilih toko pengambilan",
    "checkoutStore": "Konfirmasi Pesanan",
    "storeVerifyPhoneTitle": "Verifikasi Pesanan Pembayaran Offline & Ambil di Toko",
    "storeVerifyPhoneDesc": "Demi keamanan, kode verifikasi diperlukan untuk melanjutkan pesanan pembayaran offline & ambil di toko.",
    "storeConfirmOrder": "Konfirmasi Pesanan",
    "offlineSuccessNavTitle": "Pesanan Dikirim",
    "offlineSuccessTitle": "Pesanan Anda telah dikirim",
    "offlineSuccessDesc": "Kami telah menerima pengajuan sewa Anda. Harap tunggu peninjauan kami. Setelah disetujui, Anda dapat mengambil ponsel di toko yang dipilih.",
    "storeDetailsTitle": "Detail Toko",
    "offlineSuccessStoreLabel": "Toko",
    "storeHours": "Jam Operasional",
    "storePhone": "Telepon Toko",
    "offlineNextTitle": "Langkah selanjutnya",
    "offlineNextReview": "Kami akan meninjau pengajuan Anda. Anda akan menerima notifikasi setelah disetujui.",
    "offlineNextPickup": "Setelah disetujui, silakan datang ke toko pada jam operasional untuk mengambil ponsel.",
    "codRecommended": "Direkomendasikan",
    "codNotice": "Dengan memilih COD, harap siapkan uang pas saat pesanan diterima oleh kurir.",
    "codShippingFee": "Biaya Pengiriman COD",
    "dueAfterApproval": "Jatuh tempo setelah disetujui",
    "dueOnDelivery": "Jatuh tempo saat diterima",
    "amountDueOnApproval": "Jumlah Jatuh Tempo Saat Disetujui",
    "codShippingFeePaid": "Biaya Pengiriman COD Dibayar",
    "amountDueOnDelivery": "Jumlah Jatuh Tempo Saat Diterima",
    "awaitingApproval": "Menunggu persetujuan",
    "awaitingApprovalDesc": "Pesanan Anda sedang ditinjau. Kami akan memberi tahu Anda setelah disetujui.",
    "codShippingFeeNoticeTitle": "Pesanan COD memerlukan biaya pengiriman COD",
    "codShippingFeeNoticeDesc": "Biaya ini dibayarkan setelah pesanan Anda disetujui. Kami akan mengirim pesanan Anda hanya setelah pembayaran berhasil.",
    "codShippingFeeNoticeRefund": "Biaya Pengiriman COD tidak dapat dikembalikan untuk pembatalan terkait pelanggan atau kegagalan pengiriman.",
    "payCodShippingFee": "Bayar Biaya Pengiriman COD",
    "checkoutOnline": "Bayar Sekarang",
    "checkoutCod": "Pesan dengan COD",
    "codVerifyPhoneTitle": "Verifikasi Nomor Telepon Anda",
    "codVerifyPhoneDesc": "Demi keamanan, kode verifikasi diperlukan untuk melanjutkan COD.",
    "codPhoneLabel": "Nomor Telepon",
    "codVerificationCode": "Kode Verifikasi",
    "codVerificationCodePlaceholder": "Masukkan kode 6 digit",
    "codGetCode": "Dapatkan Kode",
    "codCodeCountdown": "{seconds}s",
    "codCodeTip": "Kode verifikasi akan dikirim melalui WhatsApp (WA) atau SMS.",
    "codConfirmOrder": "Konfirmasi Pesanan",
    "codPhoneMissing": "Nomor telepon tidak tersedia, silakan masuk ulang",
    "codCodeSent": "Kode verifikasi dikirim",
    "codCodeSendFailed": "Gagal mengirim kode verifikasi",
    "codCodeRequired": "Silakan masukkan kode verifikasi 6 digit",
    "codSuccessTitle": "Pesanan Berhasil Dikirim",
    "codSuccessDesc": "Pesanan bayar di tempat Anda telah dikonfirmasi. Harap siapkan pembayaran saat perangkat dikirim.",
    "codSuccessCardTitle": "Bayar di Tempat",
    "codSuccessCardDesc": "Harap siapkan Rp{amount} saat perangkat dikirim. Kurir akan menerima pembayaran sebelum menyerahkan perangkat.",
    "codSuccessShippingFeeNoticeDesc": "Setelah pesanan disetujui, silakan bayar Biaya Pengiriman COD secara online. Pesanan akan segera dikirim setelah pembayaran berhasil.",
    "codDeliveryReminderBefore": "Harap siapkan",
    "codDeliveryReminderAfter": "saat perangkat dikirim. Perangkat akan diserahkan setelah pembayaran selesai.",
    "dueOnApproval": "Jatuh tempo saat disetujui",
    "backToHome": "Kembali ke Beranda",
    "viewOrder": "Lihat Pesanan",
    "codLabel": "COD",
    "codAmountTitle": "Jumlah yang Dibayar Saat Diterima",
    "codPaymentReminder": "Pengingat Pembayaran COD",
    "codPaymentReminderIntro": "Anda memilih bayar di tempat (COD).",
    "codPaymentReminderDesc": "Harap siapkan Rp{amount} saat perangkat dikirim. Perangkat akan diserahkan setelah pembayaran.",
    "codReminder": "Harap siapkan Rp{amount} saat pesanan diterima.",
    "pay": "Bayar",
    "payAtStore": "Bayar sebelum pengambilan",
    "storePaymentReminder": "Pengingat Pembayaran Offline & Pengambilan",
    "storePaymentReminderDesc": "Silakan pergi ke toko yang dipilih dan bayar jumlah yang jatuh tempo saat pengambilan. Setelah pembayaran selesai, Anda dapat mengambil perangkat di toko.",
    "storePickupReminderTitle": "Pengingat Pengambilan",
    "storePickupReminderDesc": "Pembayaran sewa pertama dan deposit keamanan Anda berhasil dibayar. Silakan kunjungi toko yang dipilih sesegera mungkin untuk mengambil ponsel Anda.",
    "paymentDateCod": "Tanggal Pembayaran (COD)",
    "cancelOrder": "Batalkan Pesanan",
    "statusPaymentCompleted": "Pembayaran Selesai",
    "statusAwaitingShipment": "Menunggu Pengiriman",
    "statusAwaitingDelivery": "Menunggu Pengantaran",
    "viewLogisticsProgress": "Lihat Progres Logistik",
    "statusDelivered": "Telah Diantar",
    "statusInRental": "Dalam Masa Sewa",
    "awaitingShipmentDesc": "Pesanan Anda telah dikonfirmasi dan menunggu pengiriman.",
    "approvedAwaitingShipmentDesc": "Pesanan Anda telah disetujui dan sedang disiapkan untuk pengiriman. Informasi pelacakan akan tersedia setelah dikirim.",
    "awaitingDeliveryDesc": "Pesanan Anda sedang dalam perjalanan. Silakan konfirmasi penerimaan saat paket diterima.",
    "orderedOnFormat": "Dipesan pada {time}",
    "paidOnFormat": "Dibayar pada {time}",
    "deliveredOnFormat": "Diterima pada {time}",
    "deliveredDescription": "Perangkat Anda telah diterima. Masa sewa Anda telah dimulai.",
    "refundedNotice": "Pembayaran akan dikembalikan dalam 5 hari kerja.",
    "importantNotes": "Catatan Penting",
    "belanjaAmanTitle": "Sewa aman & nyaman",
    "belanjaAmanDesc": "Pembayaran Anda terlindungi; bayar saat perangkat diterima.",
    "codShippingFeeCheckoutSafeTitle": "Transaksi aman & terenkripsi",
    "codShippingFeeCheckoutTitle": "Biaya Pengiriman COD",
    "onlineBelanjaAmanDesc": "Pembayaran Anda terlindungi; bayar saat perangkat diterima.",
    "transaksiAman": "Transaksi aman & terenkripsi",
    "rincianPesanan": "Rincian Pesanan",
    "lihatRincian": "Lihat Rincian",
    "totalPembayaran": "Total Pembayaran",
    "securityDeposit": "Deposit Jaminan",
    "initialRentalPayment": "Pembayaran Sewa Pertama",
    "firstRentalPayment": "Pembayaran Sewa Pertama",
    "firstRentalAmount": "Jumlah sewa pertama",
    "firstMonthRentSecurityDeposit": "Jumlah sewa pertama + deposit jaminan",
    "remainingRentalPayments": "{count} pembayaran * {price}",
    "rentalFrequency": "Frekuensi Sewa",
    "totalRentalPaymentsCheckout": "Total Pembayaran Sewa",
    "additionalInfoBannerTitle": "Kirim informasi tambahan untuk pengiriman lebih cepat.",
    "additionalInfoBannerDesc": "Memberikan lebih banyak dokumen dapat membantu kami memproses dan mengirim pesanan Anda lebih cepat.",
    "returningTitle": "Pengembalian",
    "returnInProgress": "Pengembalian sedang diproses",
    "returningDescription": "Harap kembalikan perangkat pada tanggal akhir. Kami akan memeriksanya setelah perangkat kami terima.",
    "returnCompletedTitle": "Pengembalian Selesai",
    "returnCompletedDescription": "Terima kasih! Kami telah menerima dan memeriksa perangkat. Pesanan ini sekarang selesai.",
    "orderSuccessCompletedDescription": "Pembayaran selesai. Masa sewa Anda telah berakhir. Terima kasih atas pesanan Anda!",
    "deliveryAddress": "Alamat Pengiriman",
    "referenceContacts": "Kontak Referensi",
    "contactsAdded": "{count} kontak ditambahkan | {count} kontak ditambahkan",
    "product": "Produk",
    "rentalDates": "Tanggal Sewa",
    "pricePlan": "Rencana Harga",
    "copyOrderNumber": "Salin nomor pesanan",
    "copySuccess": "Nomor pesanan disalin",
    "copyFailed": "Gagal menyalin",
    "backToOrders": "Kembali ke Pesanan",
    "whatsapp": "WhatsApp",
    "paid": "Lunas",
  },
  "orderList": {
    "title": "Daftar Pesanan", // 订单列表页面标题
    "myOrders": "Pesanan Saya",
    "orderNo": "No. Pesanan {id}",
    "copySuccess": "Nomor pesanan disalin",
    "filters": { "all": "Semua", "active": "Aktif", "breaching": "Pengembalian", "completed": "Selesai", "closed": "Ditutup" },
    "deposit": "Deposit", // 订单列表页面押金标题
    "preInstallment": "Per Cicilan", // 订单列表页面分期标题
    "empty": "Belum ada pesanan", // 订单列表页面没有订单提示
    "emptyDesc": "Pesanan sewa Anda akan muncul di sini setelah Anda membuat pesanan.",
    "shopNow": "Belanja sekarang",
    "cancelSuccess": "Pesanan dibatalkan", // 取消订单成功提示
    "cancelFailed": "Gagal membatalkan pesanan", // 取消订单失败提示
    "cancelTitle": "Batalkan Pesanan", // 订单列表页面取消订单标题
    "cancelContent": "Apakah Anda yakin ingin membatalkan pesanan ini?",
    "cancelRefundDesc": "Konfirmasi pembatalan Anda. Setelah disetujui, pesanan ini akan ditutup dan jumlah yang memenuhi syarat akan dikembalikan ke akun yang Anda berikan.",
    "cancelBackTrackDesc": "Konfirmasi pembatalan Anda. Setelah disetujui, jumlah yang memenuhi syarat akan dikembalikan ke metode pembayaran awal.",
    "cancelCodDesc": "Apakah Anda yakin ingin membatalkan pesanan ini? Tindakan ini tidak dapat dibatalkan setelah dikirim.",
    "orderAmount": "Jumlah Pesanan",
    "cancelRefundAmount": "Jumlah Pengembalian Dana",
    "cancelReason": "Alasan Pembatalan", // 取消理由
    "cancelReasonPlaceholder": "Silakan jelaskan alasan pembatalan",
    "keepOrder": "Pertahankan Pesanan",
    "codCancelNoticeTitle": "Pesanan Bayar di Tempat (COD)",
    "codCancelNoticeDesc": "Anda belum melakukan pembayaran apa pun. Tidak ada pengembalian dana untuk pembatalan ini.",
    "refundAccount": "Akun Pengembalian Dana",
    "refundAccountNotice": "Pengembalian dana akan dikirim ke akun ini dalam 3-5 hari kerja setelah pembatalan dikonfirmasi.",
    "refundType": "Metode Pengembalian",
    "refundTypeEmpty": "Silakan pilih metode pengembalian",
    "bankCard": "Kartu Bank",
    "virtualAccount": "Akun Virtual",
    "eWallet": "E-Wallet",
    "bankName": "Nama Bank",
    "selectBankPlaceholder": "Silakan pilih bank",
    "selectVAPlaceholder": "Silakan pilih akun virtual",
    "selectEWalletPlaceholder": "Silakan pilih e-wallet",
    "bankEmpty": "Silakan pilih bank",
    "accountNo": "Nomor Rekening",
    "accountNoPlaceholder": "Silakan masukkan nomor rekening",
    "accountNoEmpty": "Silakan masukkan nomor rekening",
    "accountName": "Nama Pemilik Rekening",
    "accountNamePlaceholder": "Silakan masukkan nama pemilik rekening",
    "accountNameEmpty": "Silakan masukkan nama pemilik rekening",
    "accountNoError": "Format nomor rekening tidak valid",
    "accountNameError": "Nama pemilik rekening mengandung karakter yang tidak valid",
    "logistics": {
      "deliveryProgress": "Progres Pengiriman:",
      "paymentCompleted": "Pembayaran Selesai, Menunggu Pengiriman",
      "shipped": "Dikirim, Menunggu Pengiriman",
      "delivered": "Terkirim (Tertanda)",
      "preparingShipment": "Pembayaran Anda telah diterima. Barang sedang disiapkan untuk pengiriman.",
      "logistics": "Barang Anda telah dikirim dan sedang dalam perjalanan.",
      "awaitingShipment": "Menunggu pengiriman",
      "awaitingReceipt": "Menunggu penerimaan",
      "signed": "Terkirim"
    },
    "cancelStatus": {
      "titlePending": "Permintaan Pembatalan",
      "titleApproved": "Dikembalikan",
      "titleRejected": "Pembatalan Ditolak",
      "subtitleUnderReview": "Sedang Ditinjau",
      "descReviewing": "Kami sedang meninjau permintaan pembatalan Anda.",
      "descRefunded": "Pembayaran akan dikembalikan dalam 5 hari kerja.",
      "appliedOnFormat": "Diajukan pada {time}",
      "approvedOnFormat": "Disetujui pada {time}",
      "rejectedOnFormat": "Ditolak pada {time}",
      "rejectReasonFormat": "Alasan Penolakan: {reason}",
      "contactService": "Jika Anda memiliki pertanyaan, silakan hubungi customer service.",
      "withdrawRequest": "Tarik Permintaan",
      "withdrawTitle": "Tarik permintaan ini?",
      "withdrawContent": "Apakah Anda yakin ingin menarik permintaan pembatalan?",
      "withdrawSuccess": "Permintaan pembatalan ditarik"
    },
    "paymentDeadline": {
      "prefix": "Selesaikan pembayaran sebelum ",
      "suffix": "untuk menghindari pembatalan otomatis."
    },
    "status": {
      "waitingPay": 'Menunggu Pembayaran', // 待支付
      "underLease": 'Dalam Sewa', // 租赁中
      "completed": 'Selesai', // 已完成
      "closed": 'Dibatalkan', // 已关闭
      "breach": 'Selesai', // 已退租
      "breaching": 'Pengembalian dalam Proses', // 退租处理中
    },
    "options": {
      "cancel": "Batal", // 取消
      "orderDetail": "Detail Pesanan", // 订单列表页面订单详情按钮
      "rentalPlan": "Rencana Sewa", // 订单列表页面租借计划按钮
      "deliveryProgress": "Progress Pengiriman" // 订单列表页面订单物流信息按钮
      ,"payNow": "Go to Pay",
      "terminalDetail": "Detail Pengembalian"
    }
  },

  "express": {
    "title": "Express", // 物流信息标题
    "courier": "Kurir", // 快递公司名称
    "trackingNumber": "Nomor resi", // 物流信息物流单号标题
    "emptyTips": "Belum ada informasi pelacakan."
  },
  "login": {
    "title": "Genggo", // 登录页面标题
    "registerTips": "Jika Anda belum terdaftar, kami akan secara otomatis membuat akun dan login untuk Anda.",  // 登录页面注册提示
    "welcome_message": "Sewa sekarang,\n miliki nanti.", // 登录页面欢迎语
    "invalid_phone": "Silakan masukkan nomor telepon Indonesia yang valid",  // 登录页面手机号验证
    "countdown_text": "{seconds}s coba lagi", // 登录页面倒计时提示
    "get_verification_code": "Kirim Kode",  // 登录页面获取验证码按钮
    "phone_placeholder": "nomor telepon 08XX-XXX-XXXX",  // 登录页面手机号输入框提示
    "code_placeholder": "Masukkan kode verifikasi",  // 登录页面验证码输入框提示
    "login_button": "Login",  // 登录页面登录按钮
    "verification_sent": "Kode verifikasi dikirim",  // 登录页面验证码发送成功提示
    "verification_failed": "Gagal mengirim kode verifikasi", // 登录页面验证码发送失败提示
    "login_success": "Login berhasil", // 登录页面登录成功提示
    "login_failed": "Login gagal, silakan periksa kode verifikasi Anda", // 登录页面登录失败提示
    "agreement_required": "Silakan setujui perjanjian terlebih dahulu",
    "code_message": "Silakan periksa WhatsApp atau SMS Anda untuk mendapatkan kode verifikasi.",
    "subtitle_rent_to_own": "Sewa ponsel dengan opsi miliki",
    "feature_flexible": "Pembayaran fleksibel",
    "feature_trusted": "Terpercaya dan aman",
    "feature_yours": "Milik Anda selamanya"
  },
  "payment": {
    "success": "Pembayaran berhasil", // 支付成功标题
    "failed": "Pembayaran gagal", // 支付失败标题
    "timeout": "Waktu pembayaran habis", // 支付超时标题
    "successSub": "Pembayaran berhasil, harap tunggu sistem memproses", // 支付成功提示
    "failedSub": "Pembayaran gagal, silakan coba lagi", // 支付失败提示
    "timeoutSub": "Waktu pembayaran habis, silakan coba lagi", // 支付超时提示
    "paymentDetails": "Detail Pembayaran", // 单词翻译
    "orderNumber": "Order No.", // 单词翻译
    "paymentTime": "Waktu Pembayaran", // 单词翻译
    "total": "Total",   // 支付结果页总价标题
    "deposit": "Deposit", // 支付结果页押金标题
    "rent": "Sewa", // 支付结果页租金标题
    "insurance": 'Asuransi', // 支付结果页保险标题
    "penalty": 'Denda', // 支付结果页违约金标题
    "return_damage": 'Pengembalian Kerusakan',
    "btnGoHome": "Kembali ke Beranda", // 支付结果页按钮文案 翻译单词
    "btnReorder": "Pesan Lagi", // 支付结果页按钮文案 翻译单词
    "btnOrderList": "Daftar Pesanan" // 支付结果页按钮文案 翻译单词
  },
  "cycle": { // 租借周期
    "WEEKLY": 'Mingguan',   // 周
    "BI_WEEKLY": 'Dua Mingguan', // 双周
    "MONTHLY": 'Bulanan' // 月
  },
  "rentalplan": {
    "title": "Tagihan Saya", // 租赁列表标题
    "orderNumber": "Order No.", // 单词翻译
    "total": "Total", // 单词翻译
    "overdue": "Terlambat", // 单词翻译
    "paid": "Lunas",
    "unpaid": "Belum dibayar",
    "dueAmount": "Due Amount",
    "dueDate": "Due Date",
    "unknownProduct": "Produk tidak diketahui",
    "payNow": "Bayar Sekarang", // 还款按钮
    "installment": "Cicilan", // 单词翻译
    "upcoming": "Pending",
    "copyOrderNumber": "Salin nomor pesanan",
    "copySuccess": "Nomor pesanan disalin",
    "copyFailed": "Gagal menyalin",
    "empty": "Belum ada tagihan", // 列表为空提示
    "emptyDesc": "Tagihan sewa mendatang dan status pembayaran akan muncul di sini.",
    "shopNow": "Belanja sekarang",
    "securePaymentNote": "Pembayaran aman didukung oleh mitra tepercaya.",
  },
  "planDetail": { // 租赁详情页面
    "title": "Detail Rencana Sewa", // 租金详情页面标题
    "billDetails": "Detail Tagihan",
    "copyOrderNumber": "Salin nomor pesanan",
    "copySuccess": "Nomor pesanan disalin",
    "copyFailed": "Gagal menyalin",
    "orderTime": "Waktu pesanan",
    "receivedTime": "Waktu diterima",
    "billTotalAmount": "Total Jumlah",
    "billDueDate": "Tanggal Jatuh Tempo",
    "totalAmountDue": "Total yang Harus Dibayar",
    "rentAmount": "Jumlah Sewa",
    "rentAmountThisPeriod": "Sewa periode ini",
    "rentalPeriodCount": "Periode sewa",
    "payRentalBill": "Bayar Tagihan Sewa",
    "viewInstallmentPlan": "Lihat Rencana Periode Sewa",
    "viewInstallmentPlanDesc": "Lihat jadwal dan jumlah semua periode sewa",
    "payOffRemainingRent": "Lunasi Biaya Sewa Tersisa",
    "payRemainingOptional": "Bayar semua periode sewa tersisa lebih awal (opsional)",
    "securePaymentNote": "Pembayaran aman didukung oleh mitra tepercaya.",
    "payOffSecureNote": "Pembayaran aman dan data Anda terlindungi.",
    "repayPlanMonthlyTipTitle": "Pembayaran sewa Anda dijadwalkan setiap bulan.",
    "repayPlanMonthlyTip": "Semua jumlah sudah termasuk pajak yang berlaku.",
    "repayPlanPaymentTipTitle": "Tagihan sewa akan dibuat pada setiap tanggal jatuh tempo.",
    "repayPlanPaymentTip": "Harap bayar tepat waktu untuk menghindari denda keterlambatan.",
    "repayPlanEmpty": "Belum ada rencana pembayaran",
    "repayPlanLoadFailed": "Gagal memuat rencana pembayaran",
    "applyForReturn": "Ajukan Pengembalian",
    "returnDetails": "Detail Pengembalian",
    "payOffIncludesNote": "Ini termasuk semua sewa yang belum dibayar dan denda keterlambatan. Tidak ada denda tambahan yang akan dikenakan.",
    "remainingPeriods": "Periode tersisa",
    "remainingRentalPeriods": "Periode Sewa Tersisa",
    "remainingRentOnePeriod": "Sewa Tersisa ({count} Periode Sewa)",
    "remainingRentManyPeriods": "Sewa Tersisa ({count} Periode Sewa)",
    "payAmountFormat": "Bayar {amount}",
    "lateFeeForThisBill": "Biaya keterlambatan untuk tagihan ini",
    "lateFeeRuleTitle": "Biaya Keterlambatan",
    "lateFeeRuleDesc": "{amount}/hari untuk setiap periode sewa yang terlambat.",
    "lateFeeInfo": "Biaya keterlambatan dapat berlaku setelah jatuh tempo.",
    "orderNumber": "Nomor Pesanan", // 单词翻译
    "totalDue": "Total Harus Dibayar", // 单词翻译"
    "total": "Total", // 单词翻译
    "rent": "Sewa", // 单词翻译
    "deposit": 'Deposit', // 单词翻译
    "lateFee": 'Biaya Keterlambatan', // 单词翻译
    "payOff": 'Lunas', // 单词翻译
    "payNow": 'Bayar Sekarang', // 还款页还款按钮
    "selectPrev": 'Silakan centang cicilan yang ingin Anda bayar, secara berurutan.', // 按顺序勾选提醒
    "selectOverdue": 'Untuk melanjutkan, silakan pilih dan bayar cicilan yang terlambat', // 逾期勾选提醒
    "status": { // 还款页还款计划状态按钮显示
      "due": 'Harus Dibayar', // 待还款
      "unpaid": 'Belum dibayar',
      "upcoming": 'Menunggu',
      "paid": 'Dibayar', // 已还款
      "overdue": 'Terlambat', // 逾期
    },
    "terminate": 'Hentikan', // 订单列表页面终止按钮
    "paymentRulesTitle": "Aturan Pembayaran",
    "paymentRules1": "Harap selesaikan setiap pembayaran pada atau sebelum tanggal jatuh tempo.",
    "paymentRules2": "Biaya keterlambatan: Rp30.000 per hari, mulai dari hari kalender berikutnya setelah tanggal jatuh tempo.",
    "paymentRules3": "Keterlambatan pembayaran dapat mengakibatkan pengingat pembayaran, pembatasan akun, atau pembatasan sementara fitur perangkat tertentu yang tidak esensial, sesuai dengan ketentuan hukum yang berlaku.",
    "paymentRules4": "Jika semua pembayaran sewa dan jumlah terutang lainnya telah dibayar lunas, dan tidak ada tunggakan, kepemilikan perangkat akan beralih kepada Anda pada akhir masa sewa.",
    "paymentRules5": "Penghentian lebih awal setelah pengiriman dan sebelum menyelesaikan tiga periode pembayaran sewa pertama akan mengakibatkan deposit tidak dikembalikan, dan perangkat harus dikembalikan.",
  },
  "terminate": {
    "title": "Hentikan Sewa", // 终止订单页面标题
    "detailsTitle": "Detail Penghentian",
    "confirmCont": "Apakah Anda yakin ingin menghentikan sewa lebih awal?", // 终止订单confrim提示
    "tips": "Harap dicatat bahwa penghentian lebih awal dapat menimbulkan biaya yang berlaku.", // 终止订单费用提示
    "orderInfo": "Info Pesanan",  // 终止订单页面订单信息标题
    "paymentDue": "Pembayaran Harus Dibayar", // 终止订单页面待还款标题
    "penaltyFee": "Biaya Penghentian Lebih Awal", // 终止订单页面违约金标题
    "penaltyFeeHint": "Ketuk tanda tanya di atas untuk melihat cara biaya penalti dihitung.",
    "paymentDueRuleTitle": "Pembayaran Harus Dibayar",
    "paymentDueRuleDesc": "15% dari sisa sewa berlaku untuk penghentian lebih awal. Dalam 3 periode pertama, deposit tidak dikembalikan.",
    "progress": "Progress", // 终止订单页面进度标题
    "express": "Info Pengiriman", // 终止订单页面物流信息标题
    "expressNumber": "Nomor Resi", // 终止订单页面物流单号标题
    "expressCompany": "Perusahaan Pengiriman", // 终止订单页面物流单号标题
    "deposit": "Deposit", //终止订单页面押金标题
    "preInstallment": "Per Cicilan", // 终止订单页面分期标题
    "btnApply": "Kirim Permintaan", // 终止订单页面申请按钮
    "btnConfirm": "Konfirmasi Penghentian",
    "btnReapply": "Ajukan Ulang", // 终止订单页面申请按钮
    "btnPay": "Bayar Sekarang", // 终止订单页面申请按钮
    "btnExpress": "Kirim Info Pengiriman", // 终止订单页面申请按钮
    "applySuccess": "Permintaan Berhasil",  // 终止订单页面申请成功标题
    "expressSuccess": "Pengiriman Berhasil",  // 终止订单页面申请成功标题
    "expressNumberTip": "Silakan masukkan nomor resi", // 终止订单页面物流单号提示
    "expressCompanyTip": "Silakan pilih perusahaan pengiriman", // 终止订单页面物流公司提示
    "returnShippingDesc": "Harap berikan detail pengiriman pengembalian Anda.",
    "trackingPlaceholder": "Masukkan nomor resi",
    "selectShippingCompany": "Pilih perusahaan pengiriman",
    "submitConfirmTitle": "Konfirmasi permintaan penghentian?",
    "submitConfirmDesc": "Setelah dikirim, kami akan meninjau permintaan penghentian lebih awal Anda. Biaya mungkin berlaku dan Anda mungkin perlu mengembalikan perangkat.",
    "importantNotes": "Catatan Penting",
    "paid": "Dibayar",
    "paidTime": "Dibayar pada {time}",
    "earlyTerminationTitle": "Pemberitahuan Penghentian Sewa Lebih Awal",
    "earlyTerminationDesc": "Anda mengajukan untuk menghentikan sewa lebih awal. Jika disetujui, Anda harus mengembalikan perangkat sesuai dengan petunjuk pengembalian kami.",
    "earlyTerminationDesc2": "Penghentian lebih awal mungkin memerlukan pembayaran sewa yang terutang, biaya keterlambatan, biaya penghentian lebih awal, biaya perbaikan, biaya penggantian, kompensasi kehilangan perangkat, dan biaya lain yang berlaku.",
    "depositNoticeTitle": "Pemberitahuan Deposit Penting",
    "depositNoticeDesc": "Jika perangkat telah dikirimkan dan Anda menghentikan sewa sebelum menyelesaikan tiga periode pembayaran sewa pertama, deposit tidak akan dikembalikan dan perangkat harus dikembalikan.",
  },
  "additionalInfo": {
    "status": {
      "not-submitted": "Belum Verif",
      "submitted": "Ditinjau",
      "approved": "Terverifikasi"
    },
    "title": "Informasi Tambahan", // 页面标题
    "submissionResultTitle": "Hasil Pengiriman", // 页面标题
    "goHome": "Kembali ke Beranda", // 返回首页按钮
    "submit": "Konfirmasi & Kirim", // 提交按钮
    "submitSuccess": "Informasi berhasil dikirim", // 提交成功
    "submitFailed": "Gagal mengirim, silakan coba lagi", // 提交失败
    "requiredDocumentsTip": "Silakan unggah semua dokumen wajib sebelum mengirim",
    "uploadAtLeastOneTip": "Silakan unggah setidaknya satu dokumen baru",
    "driverLicensePairTip": "Silakan unggah bagian depan dan belakang SIM",
    "bpjsTkPairTip": "Silakan unggah bagian depan dan belakang kartu BPJS TK Anda",
    "fileTypeTip": "Silakan unggah file dalam salah satu format berikut: {formats}",
    "tipBanner": "Mohon tetap aktifkan ponsel Anda. Tim kami mungkin akan menghubungi Anda jika diperlukan informasi tambahan.", // 底部提示
    "terms": {
      "title": "Ketentuan Pengumpulan Data", // 条款标题
      "desc1": "Untuk memproses pengajuan rental Anda, kami akan mengumpulkan dan menggunakan dokumen serta informasi yang Anda kirimkan, termasuk KTP, Kartu Keluarga, foto wajah, rekening koran bank, slip gaji, informasi media sosial, dan dokumen pendukung lainnya.", // 条款描述
      "desc2": "Data ini digunakan untuk verifikasi identitas, penilaian kelayakan rental, pencegahan penipuan, peninjauan pesanan, pengiriman, manajemen pembayaran, pengelolaan keterlambatan, dan kepatuhan hukum.",
      "viewFull": "Lihat ketentuan lengkap", // 查看完整条款
      "agreeText": "Saya telah membaca dan menyetujui ", // 同意条款文案
      "notAgreedTip": "Silakan setujui ketentuan pengumpulan data terlebih dahulu" // 未同意条款提示
    },
    "upload": {
      "title": "Unggah Dokumen", // 文档上传标题
      "uploaded": "Terunggah", // 已上传状态
      "uploadedBankStatement": "Terunggah (3 bulan terakhir)",
      "success": "Berhasil diunggah", // 上传成功
      "failed": "Gagal mengunggah, silakan coba lagi", // 上传失败
      "fileTooLarge": "Ukuran file melebihi batas. Maksimum: {size}MB" // 上传失败
    },
    "docs": {
      "familyCard": "KK (Kartu Keluarga)", // 家庭卡
      "socialMedia": "Tangkapan Layar Akun Media Sosial", // 社交媒体截图
      "bankStatement": "Rekening Koran Bank", // 银行账单
      "payslip": "Slip Gaji / Bukti Penghasilan", // 工资单
      "driverLicenseFront": "SIM (Bagian Depan)", // 驾驶证正面
      "driverLicenseBack": "SIM (Bagian Belakang)", // 驾驶证背面
      "bpjsTkFront": "BPJS TK (Bagian Depan)",
      "bpjsTkBack": "BPJS TK (Bagian Belakang)"
    },
    "submissionResult": {
      "title": "Berhasil Dikirim",
      "desc1": "Dokumen Anda telah berhasil dikirim.",
      "desc2": "Kami akan meninjau informasi Anda dan memberi tahu setelah verifikasi selesai."
    }
  },
  "personalAdditionalInfo": {
    "title": "Informasi Saya",
    "basicVerification": "Verifikasi Dasar",
    "identityVerification": "KTP & Wajah",
    "additionalDocuments": "Informasi Tambahan",
    "intro": "Lengkapi informasi pribadi Anda untuk membantu kami memverifikasi identitas dan memproses pengajuan rental lebih cepat.",
    "documentsDesc": "Unggah dokumen yang jelas dan valid untuk pengajuan rental Anda.",
    "documentsTip": "Unggah dokumen yang jelas dan valid. Semua informasi akan disimpan dengan aman dan rahasia.",
    "underReviewTip": "Data Anda telah berhasil dikirim.\nAnda tidak perlu menunggu hasil verifikasi untuk membuat pesanan.",
    "readyTitle": "Hampir selesai!",
    "readyDesc": "Verifikasi dasar selesai. Silakan periksa informasi Anda dan kirim untuk ditinjau.",
    "readyDocumentsTip": "Semua dokumen telah diunggah. Silakan konfirmasi dan kirim untuk ditinjau.",
    "reviewBeforeSubmit": "Anda dapat meninjau atau mengunggah ulang dokumen apa pun sebelum mengirim.",
    "approvedTitle": "Semua informasi terverifikasi!",
    "approvedDesc": "Terima kasih! Informasi Anda berhasil diverifikasi. Anda siap untuk melanjutkan.",
    "rejectedTitle": "Verifikasi Gagal",
    "rejectedDesc": "Beberapa informasi yang Anda kirim tidak memenuhi persyaratan kami. Silakan unggah kembali.",
    "rejectedDocumentsTip": "Periksa alasan penolakan setiap dokumen dan unggah kembali. Semua dokumen harus jelas, lengkap, dan valid.",
    "rejectedDocumentDesc": "Dokumen tidak jelas atau tidak lengkap.",
    "reupload": "Unggah ulang",
    "uploading": "Mengunggah…",
    "verifying": "Sedang verifikasi...",
    "verify": "Verifikasi",
    "upload": "Unggah",
    "confirmSubmit": "Konfirmasi & Kirim",
    "protectedText": "Informasi Anda dilindungi dan hanya akan digunakan untuk keperluan verifikasi.",
    "notVerified": "Belum Verif",
    "loadFailed": "Informasi tidak dapat dimuat. Silakan coba lagi.",
    "retry": "Coba lagi",
    "submissionSuccessTitle": "Informasi berhasil dikirim",
    "submissionSuccessDesc": "Kami telah menerima dokumen Anda.\nMohon tunggu proses peninjauan.",
    "whatNextTitle": "Selanjutnya?",
    "whatNextDesc": "Anda kini dapat melihat dan mengajukan perangkat rental pilihan Anda. Kami akan memberi tahu jika diperlukan informasi tambahan.",
    "needHelpTitle": "Butuh bantuan?",
    "needHelpDesc": "Hubungi tim dukungan pelanggan kami.",
    "avoidRejectionTitle": "Tips agar tidak ditolak",
    "avoidRejectionDesc": "• Pastikan semua dokumen asli dan tidak diedit.\n• Ambil foto yang jelas dengan pencahayaan baik.\n• Pastikan semua teks dan tepi terlihat penuh.",
    "basic": {
      "loading": { "title": "Memuat", "desc": "Memuat status verifikasi Anda." },
      "verified": { "title": "Identitas terverifikasi", "desc": "Identitas Anda telah diverifikasi." },
      "unverified": { "title": "Verifikasi identitas diperlukan", "desc": "Verifikasi KTP dan selesaikan pengenalan wajah untuk mengonfirmasi identitas Anda." },
      "pending": { "title": "Verifikasi sedang diproses", "desc": "Verifikasi identitas Anda sedang diproses." },
      "ocr_failed": { "title": "Verifikasi KTP gagal", "summary": "KTP Anda tidak dapat diverifikasi.", "desc": "Silakan unggah ulang foto KTP yang jelas dan valid.", "bannerDesc": "Foto KTP Anda belum lolos verifikasi. Silakan unggah foto KTP yang lebih jelas.", "nextTitle": "Tips foto KTP", "nextDesc": "• Gunakan bagian depan KTP.\n• Pastikan teks, foto wajah, dan keempat sudut terlihat.\n• Hindari pantulan, bayangan, dan blur." },
      "face_failed": { "title": "Verifikasi wajah gagal", "summary": "KTP Anda sudah lolos. Verifikasi wajah belum berhasil.", "desc": "Silakan coba verifikasi wajah lagi dan pastikan wajah terlihat jelas.", "bannerDesc": "KTP Anda sudah lolos. Silakan coba verifikasi wajah lagi untuk melanjutkan.", "nextTitle": "Tips verifikasi wajah", "nextDesc": "• Pastikan wajah terlihat jelas.\n• Gunakan pencahayaan yang baik dan hindari masker atau kacamata hitam.\n• Ikuti instruksi verifikasi wajah di halaman berikutnya." },
      "error": { "title": "Tidak dapat dimuat", "desc": "Status verifikasi tidak dapat dimuat. Silakan coba lagi." }
    },
    "docs": {
      "familyCardDesc": "Unggah Kartu Keluarga Anda",
      "socialMediaDesc": "Unggah tangkapan layar akun media sosial aktif Anda (misalnya Instagram, Facebook)",
      "bankStatementDesc": "Unggah rekening koran bank 3 bulan terakhir",
      "payslipDesc": "Unggah slip gaji terbaru atau bukti penghasilan",
      "driverLicenseFrontDesc": "Unggah SIM Anda yang valid",
      "driverLicenseBackDesc": "Unggah SIM Anda yang valid",
      "bpjsTkDesc": "Unggah kartu BPJS Ketenagakerjaan Anda yang masih berlaku",
      "familyCardVerifiedDesc": "Kartu Keluarga Anda telah diverifikasi.",
      "socialMediaVerifiedDesc": "Tangkapan layar akun media sosial Anda telah diverifikasi.",
      "bankStatementVerifiedDesc": "Rekening koran bank 3 bulan terakhir Anda telah diverifikasi.",
      "payslipVerifiedDesc": "Slip gaji atau bukti penghasilan Anda telah diverifikasi.",
      "driverLicenseVerifiedDesc": "SIM Anda telah diverifikasi.",
      "bpjsTkVerifiedDesc": "Kartu BPJS Ketenagakerjaan Anda telah diverifikasi."
    }
  },
  "ktpCamera": {
    "title": "Dokumen KTP",
    "subtitle": "Pindai KTP Anda",
    "pageDesc": "Ambil foto yang jelas atau pilih bagian depan KTP dari galeri Anda. Anda dapat memeriksanya sebelum mengirim.",
    "frontTitle": "Bagian depan KTP",
    "frontOnly": "Hanya sisi depan yang diperlukan",
    "readyShort": "Siap",
    "notReady": "Belum siap",
    "checkAgain": "Perlu diperiksa",
    "emptyPreview": "Belum ada foto KTP",
    "gallery": "Galeri",
    "takePhoto": "Ambil foto",
    "retakePhoto": "Foto ulang",
    "beforeSend": "Sebelum mengirim",
    "checkTextPortrait": "Teks dan foto wajah terlihat jelas",
    "checkUseKtpFront": "Gunakan bagian depan KTP Anda, bukan foto lain",
    "checkNoGlare": "Tidak ada silau atau pantulan",
    "checkCorners": "Keempat sudut terlihat",
    "checkCornersVisible": "Posisikan KTP agar keempat sudut terlihat",
    "securityNote": "Foto KTP Anda dienkripsi saat diunggah dan hanya digunakan untuk verifikasi identitas.",
    "sendVerification": "Kirim untuk verifikasi",
    "frontHint": "Ambil foto sisi yang memuat wajah pada KTP Indonesia Anda dengan jelas.",
    "cameraPermission": "Pratinjau kamera akan muncul setelah izin diberikan",
    "openCamera": "Buka kamera",
    "choosePhoto": "Pilih foto",
    "guideTip": "Letakkan seluruh kartu di dalam bingkai. Hindari pantulan, bayangan, dan jari.",
    "align": "Sejajarkan kartu di dalam bingkai",
    "keepInsideFrame": "Pastikan keempat sudut berada di dalam bingkai",
    "moveCloser": "Dekatkan KTP ke kamera",
    "analyzing": "Memeriksa pencahayaan dan ketajaman...",
    "ready": "Terlihat baik - ketuk untuk mengambil foto",
    "capture": "Ambil foto",
    "retake": "Ambil ulang",
    "confirm": "Unggah dan lanjutkan",
    "qualityPassed": "Foto siap",
    "qualityWarning": "Periksa foto sebentar",
    "qualityPassedDesc": "Gambar telah dipotong dan dikompres untuk unggahan OCR.",
    "notKtpPhoto": "Kami tidak menemukan KTP lengkap pada foto ini. Silakan unggah bagian depan KTP Anda.",
    "cornersNotVisible": "KTP berada di luar bingkai. Pastikan keempat sudut terlihat.",
    "ktpTooSmall": "KTP terlalu kecil pada foto. Dekatkan KTP ke kamera dan coba lagi.",
    "tooDark": "Gambar terlalu gelap. Silakan ambil foto di tempat yang lebih terang.",
    "tooBright": "Cahaya pada gambar terlalu terang. Hindari pantulan pada kartu.",
    "lowQuality": "Foto belum cukup jelas. Pastikan teks, foto wajah, dan keempat sudut KTP terlihat.",
    "autoCrop": "Potong berdasarkan tepi",
    "guideCrop": "Potong berdasarkan panduan",
    "previewAlt": "Pratinjau KTP yang diproses",
    "cameraUnsupported": "Kamera tidak didukung di browser ini.",
    "cameraFailed": "Tidak dapat membuka kamera. Periksa izin browser atau pilih foto.",
    "processFailed": "Tidak dapat memproses gambar ini. Silakan pilih foto lain.",
    "invalidDocument": "Kami tidak dapat memverifikasi foto KTP ini. Ambil ulang atau unggah bagian depan KTP yang lebih jelas.",
    "documentServiceUnavailable": "Verifikasi KTP sementara tidak tersedia. Silakan coba lagi nanti.",
    "sessionExpired": "Sesi verifikasi KTP ini sudah berakhir. Silakan mulai verifikasi lagi.",
    "uploadNetworkFailed": "Tidak dapat mengunggah foto KTP. Periksa jaringan Anda dan coba lagi."
  },
  "kycV2": {
    "enterKtp": "Masuk ke verifikasi KTP...",
    "enterFace": "Masuk ke verifikasi wajah..."
  },
  "kycPop": {
    "faceVerify": "Verifikasi Wajah",
    "faceDesc": "Untuk memastikan keamanan transaksi, kami perlu memverifikasi identitas Anda melalui pengenalan wajah",
    "faceBullet1": "Memerlukan waktu sekitar 30 detik",
    "faceBullet2": "Verifikasi satu kali saja",
    "faceBullet3": "Data Anda dilindungi dengan aman",
    "faceNote": "CATATAN:",
    "faceEnvTip": "Pastikan Anda berada di lingkungan yang cukup terang dan wajah Anda terlihat jelas",
    "facePrivacy": "Saya setuju dengan pengumpulan dan pemrosesan data biometrik saya untuk tujuan verifikasi identitas sesuai dengan ",
    "facePrivacyLink": "\"Kebijakan Privasi\"",
    "faceBtn": "Mulai Verifikasi",
    "identityVerify": "Verifikasi Identitas",
    "identityDesc": "Untuk memastikan keamanan transaksi, kami perlu memverifikasi identitas Anda",
    "identityBullet1": "Memerlukan waktu sekitar 30 detik",
    "identityBullet2": "Verifikasi satu kali saja",
    "identityBullet3": "Data Anda dilindungi dengan aman",
    "identityStep1": "1: Ambil foto ID Anda",
    "identityStep2": "2: Selesaikan verifikasi wajah",
    "identityNote": "CATATAN:",
    "identityEnvTip": "Gunakan fitur ini di lingkungan yang cukup terang",
    "identityPrivacy": "Saya setuju dengan pengumpulan dan pemrosesan identitas dan data biometrik saya untuk tujuan verifikasi dan menerima ",
    "identityPrivacyLink": "\"Kebijakan Privasi\"",
    "identityBtn": "Mulai Verifikasi",
    "startVerification": "Mulai Verifikasi",
    "authResultSuccess": "Verifikasi Berhasil",
    "redirecting": "Mengalihkan ke pembayaran",
    "continueToPayment": "Lanjut ke Pembayaran",
    "authResultRetryDesc": "Pastikan wajah Anda terlihat jelas dan pencahayaan mencukupi",
    "authResultFailTitle": " wajah gagal beberapa kali. Silakan coba lagi nanti",
    "authResultOcrFailDesc1": "Informasi ID tidak konsisten. Harap gunakan kartu identitas yang valid milik Anda sendiri.",
    "authResultFailDesc1": "Pesanan Anda saat ini telah dibatalkan.",
    "authResultFailDesc2": "Anda dapat membuat pesanan baru setelahnya.",
    "authResultBack": "Kembali",
    "paymentTitle": "Pembayaran",
    "paymentDesc": "Pindai kode QR menggunakan e-wallet Anda",
    "paymentExpiration": "Kode QR kedaluwarsa dalam",
    "paymentStep1": "Buka e-wallet Anda (mis. OVO / DANA)",
    "paymentStep2": "Ketuk \"Pindai\"",
    "paymentStep3": "Pindai kode QR untuk menyelesaikan pembayaran",
    "saveQR": "Simpan QR",
    "paymentExpired": "Pembayaran kedaluwarsa, silakan coba lagi"
  },
}
export default id;
